import "zod/compile";
import { z } from "zod";

export const dataLabelFieldSchema = z.object({
  fieldId: z.uuid(),
  fieldName: z.string().min(1),
  title: z.string().trim().min(1).max(255),
  description: z.string().trim().max(2000).nullable(),
});
export const dataLabelsSchema = z.object({
  title: z.string().trim().min(1).max(255),
  description: z.string().trim().max(2000).nullable(),
  fields: z.array(dataLabelFieldSchema).max(500),
});
export const dataLabelDraftSchema = z.object({
  id: z.uuid(),
  createdAt: z.string().datetime(),
  baselineFingerprint: z.string().length(64),
  sampleLinkId: z.uuid().nullable(),
  labels: dataLabelsSchema,
});
export type DataLabels = z.infer<typeof dataLabelsSchema>;
export type DataLabelDraft = z.infer<typeof dataLabelDraftSchema>;
